import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row, Spin } from 'antd';
import {
    DeleteOutlined,
    EditOutlined,
    ExclamationCircleFilled,
} from '@ant-design/icons';

import Headline from '../../../UI/Headline/Headline';
import TrailService from '../../../../Services/api/TrailService';
import TrailEquipmentForm from './TrailEquipmentForm/TrailEquipmentForm';
import EquipmentService from '../../../../Services/api/EquipmentService';
// import Notifications from '../../../../Services/Notifications/Notifications';

function TrailEquipments({ companyId, trailId }) {
    const [trail, setTrail] = useState({});
    const [equipments, setEquipments] = useState([]);

    const [showModal, setShowModal] = useState(false);
    const [form] = Form.useForm();
    const [item, setItem] = useState(null); // equipmentToTrail // todo: remove this hook
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTrail = async () => {
            const trailData = await TrailService.findOne(trailId);
            setTrail(trailData);
        };
        const fetchEquipments = async () => {
            const equipmentsData = await EquipmentService.getAll(companyId);
            setEquipments(equipmentsData);
        };

        Promise.all([fetchTrail(), fetchEquipments()]).then(() => {
            setLoading(false);
        });
        // eslint-disable-next-line
    }, []);

    const save = async () => {
        await form.validateFields();

        const editMode = !!item;
        const data = form.getFieldsValue();

        // console.log(data, editMode);
        // setLoading(true);
        try {
            if (editMode) {
                await EquipmentService.updateOnTrail(
                    data.equipment.id,
                    trailId,
                    data.price,
                    companyId,
                );
            } else {
                await EquipmentService.addToTrail(
                    data.equipment.id,
                    trailId,
                    data.price,
                    companyId,
                );
            }
            // Notifications.success('Zapisano');
            // window.location.href = '/admin/routes';
            window.location.reload();
        } catch (err) {
            console.log('error');
            alert('Coś poszło nie tak');
        }
        // setLoading(false);
    };

    const remove = async (equipmentToTrail) => {
        try {
            await EquipmentService.removeFromTrail(
                equipmentToTrail.equipment.id,
                trailId,
            );
            // Notifications.success('Zapisano');
            // window.location.href = '/admin/routes';
            window.location.reload();
        } catch (err) {
            console.log('error');
            alert('Coś poszło nie tak');
        }
        // Notifications.success('Usunięto');
    };

    const editHandler = (equipmentToTrail) => {
        setShowModal(true);
        setItem(equipmentToTrail);
        form.setFieldsValue(equipmentToTrail);
    };

    const addHandler = () => {
        setShowModal(true);
        setItem(null);
        form.resetFields();
    };

    const cancelEditHandler = () => {
        setShowModal(false);
        setItem(null);
        form.resetFields();
    };

    const deleteHandler = (equipmentToTrail) => {
        const { id } = equipmentToTrail;
        Modal.confirm({
            title: 'Na pewno chcesz usunąć sprzęt z tej trasy?',
            icon: <ExclamationCircleFilled />,
            content:
                'Sprzęt nie zostanie całkiem usunięty, ale nie będzie już dostępny na tej trasie.',
            onOk() {
                remove(equipmentToTrail);
            },
            okText: 'Usuń',
            cancelText: 'Anuluj',
        });
    };

    return (
        <Card bordered>
            <Spin spinning={loading}>
                <Headline title={`Sprzęty na trasie "${trail.title}"`} />

                {trail.equipmentToTrail?.map((equipmentToTrail) => (
                    <Row key={equipmentToTrail.id}>
                        <Col span={24} md={16}>
                            #{equipmentToTrail.equipment.id} &nbsp;
                            {equipmentToTrail.equipment.title} &nbsp; (
                            {equipmentToTrail.equipment.count} szt.) <br />
                            <small className="text-muted">
                                {equipmentToTrail.equipment.description}
                            </small>
                        </Col>
                        <Col span={24} md={8} style={{ textAlign: 'right' }}>
                            <Button
                                type="primary"
                                danger
                                icon={<DeleteOutlined />}
                                onClick={() => deleteHandler(equipmentToTrail)}
                            />
                            <Button
                                type="primary"
                                icon={<EditOutlined />}
                                onClick={() => editHandler(equipmentToTrail)}
                                style={{ marginLeft: 10 }}
                            />
                        </Col>
                        <Col span={24}>
                            <hr />
                        </Col>
                    </Row>
                ))}

                {!trail.equipmentToTrail?.length && (
                    <p>Trasa nie ma jeszcze żadnego przypisanego sprzętu.</p>
                )}

                <Button type="primary" onClick={addHandler}>
                    Dodaj sprzęt do trasy
                </Button>

                <Modal
                    open={showModal}
                    title={
                        item
                            ? `Edytuj sprzęt na trasie "${trail.title}"`
                            : `Dodaj sprzęt do trasy "${trail.title}"`
                    }
                    okText="Zapisz"
                    cancelText="Anuluj"
                    destroyOnClose
                    onCancel={cancelEditHandler}
                    onOk={save}
                >
                    <TrailEquipmentForm
                        equipmentToTrail={item}
                        equipments={equipments}
                        trail={trail}
                        form={form}
                    />
                </Modal>
            </Spin>
        </Card>
    );
}

export default TrailEquipments;
